import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import Config from 'config';
import axios from 'axios';
import { parseXMLRequestResponse } from '../utils/util';
import { TRequestError } from './types';

export interface ICheckWizardSlice {
  isLoading: boolean;
  redirectURL: TCheckWizardResponse | TRequestError | null;
}

export type TCheckWizardResponse = {
  payload: {
    url: string;
  };
};

export const fetchIfWizard = createAsyncThunk<TCheckWizardResponse>(
  'checkWizardSlice/fetchIfWizard',
  async (_params, thunkAPI) => {
    try {
      const response = await axios.post(Config.FORM_CHECK_IF_WIZARD_URL);
      return parseXMLRequestResponse(response) as TCheckWizardResponse;
    } catch (err) {
      const error = (err as TRequestError).response;
      return thunkAPI.rejectWithValue(error.data);
    }
  },
);

const checkWizardSlice = createSlice({
  name: 'checkWizardSlice',
  initialState: {
    isLoading: false,
    redirectURL: null,
  } as ICheckWizardSlice,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchIfWizard.pending, (state) => {
      state.redirectURL = null;
      state.isLoading = true;
    });
    builder.addCase(
      fetchIfWizard.fulfilled,
      (state, action: PayloadAction<TCheckWizardResponse>) => {
        state.redirectURL = action.payload as ICheckWizardSlice['redirectURL'];
        state.isLoading = false;
      },
    );
    builder.addCase(fetchIfWizard.rejected, (state, action) => {
      state.isLoading = false;
      state.redirectURL = action.payload as TRequestError;
    });
  },
});

export default checkWizardSlice.reducer;
